import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchHeader = ({ searchQuery, onSearchChange, sortBy, onSortChange, viewMode, onViewModeChange }) => {
  const [isVoiceSearchActive, setIsVoiceSearchActive] = useState(false);

  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'price_low', label: 'Price: Low to High' },
    { value: 'price_high', label: 'Price: High to Low' },
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'area_large', label: 'Area: Large to Small' },
    { value: 'area_small', label: 'Area: Small to Large' }
  ];

  const handleVoiceSearch = () => {
    setIsVoiceSearchActive(!isVoiceSearchActive);
    // Voice search implementation would go here
    setTimeout(() => {
      setIsVoiceSearchActive(false);
    }, 3000);
  };

  const suggestions = [
    "2 BHK in Koramangala",
    "Furnished apartment near Metro",
    "Villa in Whitefield",
    "Studio apartment under ₹20,000",
    "3 BHK with parking"
  ];

  return (
    <div className="bg-surface border border-border rounded-lg shadow-property-card p-4 mb-6">
      {/* Main Search Bar */}
      <div className="flex items-center space-x-3 mb-4">
        <div className="flex-1 relative">
          <div className="relative">
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary" 
            />
            <Input
              type="search"
              placeholder="Search by location, property type, or keywords..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 pr-12"
            />
            <Button
              variant="ghost"
              size="sm"
              onClick={handleVoiceSearch}
              className={`absolute right-2 top-1/2 transform -translate-y-1/2 ${
                isVoiceSearchActive ? 'text-error' : 'text-text-secondary'
              }`}
              iconName={isVoiceSearchActive ? "MicOff" : "Mic"}
            >
            </Button>
          </div>
          
          {/* Voice Search Indicator */}
          {isVoiceSearchActive && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-surface border border-border rounded-lg shadow-modal p-3 z-10">
              <div className="flex items-center space-x-2 text-error">
                <div className="w-2 h-2 bg-error rounded-full animate-pulse"></div>
                <span className="text-sm font-medium">Listening...</span>
              </div>
              <p className="text-xs text-text-secondary mt-1">Speak clearly and mention location, property type, or budget</p>
            </div>
          )}
        </div>

        <Button
          variant="default"
          iconName="Search"
          iconPosition="left"
        >
          Search
        </Button>
      </div>

      {/* Search Suggestions */}
      {searchQuery === '' && (
        <div className="mb-4">
          <p className="text-sm text-text-secondary mb-2">Popular searches:</p>
          <div className="flex flex-wrap gap-2">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => onSearchChange(suggestion)}
                className="px-3 py-1 bg-muted text-text-secondary text-sm rounded-full hover:bg-primary hover:text-primary-foreground transition-quick"
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Controls Row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* Sort Options */}
          <div className="flex items-center space-x-2">
            <Icon name="ArrowUpDown" size={16} className="text-text-secondary" />
            <Select
              placeholder="Sort by"
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              className="min-w-[160px]"
            />
          </div>

          {/* Quick Filters */}
          <div className="hidden md:flex items-center space-x-2">
            <Button variant="ghost" size="sm" iconName="Filter" iconPosition="left">
              More Filters
            </Button>
            <Button variant="ghost" size="sm" iconName="MapPin" iconPosition="left">
              Near Me
            </Button>
            <Button variant="ghost" size="sm" iconName="Bookmark" iconPosition="left">
              Saved Searches
            </Button>
          </div>
        </div>

        {/* View Mode Toggle */}
        <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
          <Button
            variant={viewMode === 'grid' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('grid')}
            iconName="Grid3X3"
          >
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            iconName="List"
          >
          </Button>
          <Button
            variant={viewMode === 'map' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('map')}
            iconName="Map"
          >
          </Button>
        </div>
      </div>

      {/* Active Filters Display */}
      <div className="flex items-center space-x-2 mt-3">
        <span className="text-sm text-text-secondary">Active filters:</span>
        <div className="flex flex-wrap gap-2">
          <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full flex items-center space-x-1">
            <span>Bangalore</span>
            <button className="hover:text-primary/70">
              <Icon name="X" size={12} />
            </button>
          </span>
          <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full flex items-center space-x-1">
            <span>2 BHK</span>
            <button className="hover:text-primary/70">
              <Icon name="X" size={12} />
            </button>
          </span>
          <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full flex items-center space-x-1">
            <span>₹15,000 - ₹30,000</span>
            <button className="hover:text-primary/70">
              <Icon name="X" size={12} />
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;